import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import * as constant from '../constants/constants';
import { StorageService } from '../services/storage.service';
import { UtilService } from '../services/util.service';

@Pipe({
  name: 'customDatePipe',
})
export class customDatePipe implements PipeTransform {
  date_format: string | null = '';

  constructor(
    private storageService: StorageService,
    private utilService: UtilService
  ) { }

  async getConfiguration(key: any) {
    let data = await this.storageService.get(key)
    this.date_format = data[constant.configuration_keys.date_format];
  }

  async transform(value: any, format?: string) {
    // if value is undefined/null/empty return -
    if (this.utilService.isNullOrEmptyOrUndefined(value)) {
      return '-';
    }

    // if custom format is given, use that
    if (format) {
      this.date_format = format;
    } else {
      await this.getConfiguration(constant.storage_keys.configuration);

      // in case date_format is not set in session storage, use dd/mm/yyyy as default
      if (!this.date_format) {
        this.date_format = 'dd/MM/yyyy';
      }
    }

    // to handle different types of input dates
    // create standard date from given date
    let standard_date = new Date(value).setHours(constant.common.zero, constant.common.zero, constant.common.zero, constant.common.zero);

    let datePipe = new DatePipe(constant.common.locale);
    let transformed_date = datePipe.transform(standard_date, this.date_format);

    return transformed_date;
  }
}